export const hasPermutive = (
  countryCode: string,
  edition: string,
  isFansided: boolean,
  isSi: boolean,
): boolean => {
  const isUS = countryCode === 'US';
  const isCanada = countryCode === 'CA';

  // Only show Permutive for US and Canada sites.
  if (!isUS && !isCanada) return false;

  // Don't show Permutive for SI Kids and SI High School.
  if (edition === 'si_kids' || edition === 'high_school') return false;

  // Show Permutive for SI sites.
  if (isSi) return true;

  // Show Permutive for FanSided sites
  return isFansided;
};
